<div mat-dialog-title>
  <h2>Stimulus</h2>
  <eiq-button
    [title]="'Close stimulus picker dialog'"
    [color]="'light'"
    [style]="'icon'"
    [icon]="faClose"
    class="mat-dialog-title__close"
    (clicked)="onCancel()"
  ></eiq-button>
</div>
<div mat-dialog-content class="eiq-media-picker-dialog__content" [class.multiple]="data.multipleInd">
  @if (uploadedFilesPreview$().length > 0) {
    @for (file of uploadedFilesPreview$(); track file.file.name) {
      <div class="eiq-media-picker-dialog__file" [class.failed]="file.failed">
        @if (file.file.type === fileType.VideoMp4) {
          <video controls>
            <source [src]="file.src" />
          </video>
        } @else if (file.file.type === fileType.AudioMp3) {
          <audio controls>
            <source [src]="file.src" />
          </audio>
        } @else if (file.isImage) {
          <img [alt]="file.file.name" [src]="file.src" />
        }

        <div class="eiq-media-picker-dialog__file-info">
          <div class="eiq-media-picker-dialog__file-info__main">
            <fa-icon [icon]="faFile"></fa-icon>
            <div class="eiq-media-picker-dialog__file-info__details">
              <span class="fs__md fw__400 file-name">{{ file.file.name }}</span>
              <span class="fs__sm fw__400 caption file-size">{{ file.size }} MB {{ file.failed ? 'The file is too big' : '' }}</span>
            </div>
          </div>
          <button mat-icon-button (click)="onDelete($index)">
            <fa-icon [icon]="faTrash"></fa-icon>
          </button>
        </div>
      </div>
    }
    @if (data.multipleInd && (!data.maxNumberOfFiles || uploadedFilesPreview$().length < data.maxNumberOfFiles)) {
      <div class="eiq-media-picker-dialog__file add-more">
        <input type="file" #fileDropRef [accept]="data.types" [multiple]="true" (change)="onUploadMore($event)" />
        <fa-icon [icon]="faPlus"></fa-icon>
      </div>
    }
  } @else {
    <eiq-file-uploader
      [acceptedTypes]="data.types"
      [acceptedTypesText]="fileTypeTexts$()"
      [maxSize]="maxSize"
      [multiple]="data.multipleInd"
      (uploaded)="onUpload($event)"
    ></eiq-file-uploader>
  }
</div>
<div mat-dialog-actions>
  @if (data.multipleInd && !!data.maxNumberOfFiles) {
    <span class="text__md fw__500">Only {{ data.maxNumberOfFiles }} files are allowed</span>
  }
  <eiq-button [text]="'Close'" [color]="'light'" [style]="'stroked'" (clicked)="onCancel()"></eiq-button>
  <eiq-button
    [text]="'Save'"
    [disabled]="uploadedFilesPreview$().length === 0 || (!!data.maxNumberOfFiles && uploadedFilesPreview$().length > data.maxNumberOfFiles)"
    [loading]="uploading$()"
    [loadingText]="'Uploading (' + uploadedFiles$().length + ' / ' + uploadedFilesPreview$().length + ')'"
    (clicked)="onSave()"
  ></eiq-button>
</div>
